<template>
  <div class="match">
    <loading-state :state="state"></loading-state>
    <div v-if="match">
      <section class="fullwidth" v-if="match.info.status.isStarted">
        <div class="center-title">
          <h2 class="info">{{ minuteLabel }}</h2>
        </div>
      </section>
      <section class="fullwidth compact">
        <div class="part-first "><h2>{{match.info.home.name}}</h2></div>
        <div class="part-last "><h2>{{match.info.away.name}}</h2></div>
      </section>
      <section class="fullwidth" v-if="match.score">
        <div class="part-first">
          <div class="highlight main">{{match.score.home}}</div>
          <div class="sub" v-if="match.score.detail.second_half">
            <div
              v-for="scoreKind in scoreOrder"
              v-if="match.score.detail[scoreKind.key]"
              :key="scoreKind.key"
              :class="[scoreKind.key]">
                <span class="silent">{{scoreKind.name}}: </span>
                {{match.score.detail[scoreKind.key].home}}
            </div>
          </div>
        </div>
        <div class="part-last">
          <div class="highlight main">{{match.score.away}}</div>
          <div class="sub" v-if="match.score.detail.second_half">
            <div
              v-for="scoreKind in scoreOrder"
              v-if="match.score.detail[scoreKind.key]"
              :key="scoreKind.key"
              :class="[scoreKind.key]">
                {{match.score.detail[scoreKind.key].away}}
            </div>
          </div>
        </div>
      </section>
      <section class="fullwidth" v-if="match.score">
        <div class="part-first">
          <div class="sub">
            <template
              v-for="session in match.timeline"
            >
              <div
                v-for="timeline in session.items"
                v-if="timeline.event.isGoal && timeline.isForTeam(match.info.home.key)"
                :key="timeline.key">
                <span v-if="timeline.data.scorer"></span>
                  <span class="small-font" v-if="timeline.data.assist">(<span v-if="timeline.data.goal_type == 'penalty_goal'">Pen </span>assist: <span @click="onPlayerSelected(timeline.data.assist)">{{match.players[timeline.data.assist].jersey_name}})&nbsp;</span></span>
                  <span class="small-font" v-else-if="timeline.data.assist_drawn">(Ass Dwn:
                    <span @click="onPlayerSelected(timeline.data.assist_drawn)" class="clickable">{{match.players[timeline.data.assist_drawn].jersey_name}})&nbsp;</span>
                  </span>
                  <span class="small-font" v-else-if="timeline.data.own_goal_assist">(OG Ass: <span @click="onPlayerSelected(timeline.data.own_goal_assist)">{{match.players[timeline.data.own_goal_assist].jersey_name}})&nbsp;</span></span>
                  <span class="small-font" v-else-if="timeline.data.rebound_assist">(Reb Ass:
                    <span @click="onPlayerSelected(timeline.data.rebound_assist)" class="clickable">{{match.players[timeline.data.rebound_assist].jersey_name}})&nbsp;</span>
                  </span>
                  <span v-if="timeline.data.goal_type !== 'goal'" class="silent small-font">{{timeline.data.goal_type | capitalise}}</span>
                  <span class="clickable" @click="onPlayerSelected(timeline.data.scorer)">
                    {{match.players[timeline.data.scorer].jersey_name}}</span>
                  <span class="highlight">
                    {{timeline.time.label}}
                  </span>
              </div>
            </template>
          </div>
        </div>
        <div class="part-last">
            <template
              v-for="session in match.timeline"
            >
              <div
                v-for="timeline in session.items"
                v-if="timeline.event.isGoal && timeline.isForTeam(match.info.away.key)"
                :key="timeline.key">
                <span v-if="timeline.data.scorer"></span>
                  <span class="highlight">
                    {{timeline.time.label}}
                  </span>
                  <span class="clickable" @click="onPlayerSelected(timeline.data.scorer)">{{match.players[timeline.data.scorer].jersey_name}}</span>
                  <span v-if="timeline.data.goal_type !== 'goal'" class="silent small-font"> {{timeline.data.goal_type | capitalise}}</span>
                  <span v-if="timeline.data.assist" class="small-font">&nbsp;(<span v-if="timeline.data.goal_type == 'penalty_goal'">Pen</span>assist:
                    <span @click="onPlayerSelected(timeline.data.assist)" class="clickable">{{match.players[timeline.data.assist].jersey_name}})</span>
                  </span>
                  <span class="small-font" v-else-if="timeline.data.assist_drawn">&nbsp;(Ass Dwn:
                    <span @click="onPlayerSelected(timeline.data.assist_drawn)" class="clickable">{{match.players[timeline.data.assist_drawn].jersey_name}})</span>
                  </span>
                  <span class="small-font" v-else-if="timeline.data.own_goal_assist">&nbsp;(OG Ass: 
                    <span @click="onPlayerSelected(timeline.data.own_goal_assist)" class="clickable">{{match.players[timeline.data.own_goal_assist].jersey_name}})</span>
                  </span>
                  <span class="small-font" v-else-if="timeline.data.rebound_assist">(Reb Ass:
                    <span @click="onPlayerSelected(timeline.data.rebound_assist)" class="clickable">{{match.players[timeline.data.rebound_assist].jersey_name}})&nbsp;</span>
                  </span>
              </div>
            </template>
        </div>
      </section>
      <section class="fullwidth" v-else-if="match.info.status.isNotStarted">
        <div class="center-title">
          <h2 class="info">{{match.info.start_at | relativeShortDateTime}}</h2>
        </div>
      </section>
      <section class="fullwidth" v-else>
        <div class="center-title">
          <h2 class="info">{{match.info.status.value | capitalise}}</h2>
        </div>
      </section>

      <div class="sub-menu sticky" v-if="sections.length > 1">
        <ul>
          <li
            v-for="section in sections" :key="section.key"
            :class="{active: section.value == activeSection.value}"
            @click="activeSection = section">{{section.value | capitalise}}</li>
        </ul>
      </div>

      <div v-if="activeSection.isInfo">
        <section class="fullwidth col-center">
          <div class="acol onbox">
            <h2 class="info">
              <router-link class="clean" :to="{name:'tournament', params: {key: match.info.tournament.key}}">
                {{match.info.tournament.name}}
              </router-link>
            </h2>

            <ul>
              <li><label>Start:</label> {{match.info.start_at | relativeShortDateTime}}</li>
              <li><label>Venue:</label> {{match.venue}}</li>
              <li><label>Round:</label>
                <router-link :to="{name:'tournamentRound', params:{key:match.info.tournament.key, roundkey:match.info.round.key}}">
                  {{match.info.round.name}}</router-link>
              </li>
               <li><label>Status:</label> {{match.info.data_review_checkpoint | capitalise('-')}}
                  | {{match.info.status_overview | capitalise('-')}}
                  | {{match.info.status.key}}</li>
              <li v-if="match.info.state"><label>State:</label> {{match.info.state | capitalise('-')}}</li>
            </ul>
          </div>
          <div class="acol onbox" v-if="match.result && match.result.player_of_the_match">
            <div class="">
              <div v-for="playerKey in match.result.player_of_the_match" :key="playerKey">
                <h2 class="info clickable" @click="onPlayerSelected(playerKey)">
                  {{match.players[playerKey].jersey_name}}
                  </h2>
                <div class="silent">Player of the match</div>
                <div>
                  <span v-if="match.players[playerKey].stats.goal.conceded">
                    Goals conceded: <span>{{match.players[playerKey].stats.goal.conceded}}</span>
                  </span>
                  <span v-if="match.players[playerKey].stats.penalty.saved">
                    Penalty Saved: <span>{{match.players[playerKey].stats.penalty.saved}}</span>
                  </span>
                  <span v-if="match.players[playerKey].stats.goal.scored">
                    Goals Scored: <span>{{match.players[playerKey].stats.goal.scored}}</span>
                  </span>
                  <span v-if="match.players[playerKey].stats.goal.assist">
                    Goals Assist: <span>{{match.players[playerKey].stats.goal.assist}}</span>
                  </span>
                  <span v-if="match.players[playerKey].stats.penalty.scored">
                    Penalty Scored: <span>{{match.players[playerKey].stats.penalty.scored}}</span>
                  </span>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>

      <football-match-stats
        :match="match"
        @playerSelected="onPlayerSelected"
        v-if="activeSection.isStats"></football-match-stats>
      <match-fantasy
        :match="match"
        @playerSelected="onPlayerSelected"
        v-if="activeSection.isFantasy"></match-fantasy>

      <!-- <fantasy-game
        :match="match"
        v-if="activeSection.isGame"></fantasy-game> -->

      <football-match-team
        @playerSelected="onPlayerSelected"
        :match="match"
        v-if="activeSection.isTeam"></football-match-team>     
      <football-match-timeline
        :match="match"
        v-if="activeSection.isTimeline"></football-match-timeline> 

      <!-- <football-manual-stats :match="match"
        @playerSelected="onPlayerSelected"
        v-if="activeSection.isManualStats"></football-manual-stats> -->

      <div class="app-right-dailog" :class="{visible: selectedPlayer != null}">
        <div class="tools"><button @click="selectedPlayer=null" class="box">Close</button></div>
        <div class="content"  v-if="selectedPlayer">
          <h2>{{selectedPlayer.jersey_name}} ({{selectedPlayer.jersey_number}})</h2>
          <div class="dl-box">
            <div>{{selectedPlayer.legal_name}}</div>
            <div><small class="silent">{{selectedPlayer.name}}</small> </div>
          </div>
          <div class="dl-box" v-if="match.info.status.isNotStarted">
            <div>{{selectedPlayer.role.value | capitalise}}</div>
          </div>
          <template v-else>
            <div class="dl-box">
              <div class="name">{{selectedPlayer.role.value | capitalise}}
                <div><small class="silent">{{selectedPlayer.match_role}}</small> </div>
              </div>
              <dl>
                <dt>Minutes Played</dt>
                <dd>{{selectedPlayer.stats.minutes_played}}</dd>
                <dt>Clean Sheet</dt>
                <dd>{{(selectedPlayer.stats.clean_sheet)? 'Yes': 'No'}}</dd>
                <dt>Clean Sheet By Match Role</dt>
                <dd>{{(selectedPlayer.stats.clean_sheet_by_match_role)? 'Yes': 'No'}}</dd>
              </dl>
            </div>
            <div
              class="dl-box"
              v-for="key in ['goal', 'card', 'foul', 'penalty', 'penalties_shootout']"
              :key="key"
              >
              <div class="name">{{key | capitalise}}</div>
              <dl>
                <template v-for="prop in Object.keys(selectedPlayer.stats[key])">
                  <dt>{{prop | capitalise}}</dt>
                  <dd>{{selectedPlayer.stats[key][prop]}}</dd>
                </template>
              </dl>
            </div>
            <div class="dl-box">
              <div class="name">Manual Stats</div>
              <dl>
                <dt>Total passes</dt>
                <dd v-if="selectedPlayer.stats.passes">{{selectedPlayer.stats.passes}}</dd><dd v-else>-</dd>
                <dt>Shot On Target</dt>
                <dd v-if="selectedPlayer.stats.shot_on_target">{{selectedPlayer.stats.shot_on_target}}</dd><dd v-else>-</dd>
                <dt>Tackles</dt>
                <dd v-if="selectedPlayer.stats.tackles">{{selectedPlayer.stats.tackles}}</dd><dd v-else>-</dd>
                <dt>Goal Saved</dt>
                <dd v-if="selectedPlayer.stats.goal.saved">{{selectedPlayer.stats.goal.saved}}</dd><dd v-else>-</dd>
              </dl>
            </div>
          </template>
          <div class="dl-box">
            <div class="name"></div>
            <div>
              <router-link
                      class="box"
                      :to="{name:'tournamentPlayer', params:{key:match.info.tournament.key, playerkey:selectedPlayer.key}}">Tournament Stats</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FootballMatch } from '@/models/match'
import { FootballPush } from '@/models/push'
import { DataState, AppState } from '@/state'
import { Enum } from '@/helpers/enum'
import MatchFantasy from '@/components/football/MatchFantasy.vue'
import FootballManualStats from '@/components/football/FootballManualStats.vue'
import FootballMatchTimeline from '@/components/football/FootballMatchTimeline.vue'
import Fantasy from '@/components/cricket/fantasy/Fantasy.vue'
import AppEvents from '@/appevents'

import Vue from 'vue'

export const MatchViewSection = new Enum({
  Info: 'info',
  Team: 'teams',
  Fantasy: 'fantasy',
  // Game: 'game',
  Timeline: 'timeline',
  Stats: 'stats',
  ManualStats: 'manual stats',
})

export default {
  name: 'match',
  components: {
    'MatchFantasy': MatchFantasy,
    'FootballManualStats': FootballManualStats,
    'FantasyGame': Fantasy,
    'FootballMatchTimeline': FootballMatchTimeline
  },
  data () {
    return {
      matchKey: this.$route.params.key,
      match: null,
      selectedPlayer: null,
      minuteLabel: '',
      pushId: null,
      pushInited: false,
      state: DataState.newLoading(),

      activeSection: MatchViewSection.Info,
      sections: [], // ['Info', 'Team', 'Timeline', 'Stats'],

      scoreOrder: [
        { key: 'first_half', name: 'FH' },
        { key: 'second_half', name: 'SH' },
        { key: 'extra_time_first_half', name: 'ET FH' },
        { key: 'extra_time_second_half', name: 'ET SH' },
        { key: 'penalty', name: 'Penalty' }
      ]
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  created () {
    this.$globalEvents.$on(AppEvents.fantasyCreateTeamVisible, this.onCreateTeamVisible)
    this.$globalEvents.$on(AppEvents.fantasyCreateTeamDone, this.onFantasyParticipated)
    this.$globalEvents.$on(AppEvents.fantasyResigned, this.onFantasyParticipated)
  },
  destroyed () {
    this.$globalEvents.$off(AppEvents.fantasyCreateTeamVisible, this.onCreateTeamVisible)
    this.$globalEvents.$off(AppEvents.fantasyCreateTeamDone, this.onFantasyParticipated)
    this.$globalEvents.$off(AppEvents.fantasyResigned, this.onFantasyParticipated)
    FootballPush.instance().stopMatchUpdate(this.matchKey, this.pushId)
  },
  methods: {
    onViewOpenned () {
      this.matchKey = this.$route.params.key
      const newTitle = 'loading...'
      AppState.updateActivePage(`match_${this.matchKey}`)
      AppState.updateTitles(newTitle, newTitle)

      FootballMatch.fetch(this.matchKey).then(match => {
        this.onMatchUpdated(match)
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    prepareToReopen () {
      this.match = null
      this.pushId = null
      this.pushInited = false
      this.selectedPlayer = null
      this.minuteLabel = ''
      this.state = DataState.newLoading()
      this.activeSection = MatchViewSection.Info
      this.sections = []
    },
    refreshView () {

    },

    onPlayerSelected (playerKey) {
      this.selectedPlayer = this.match.players[playerKey]
      // AppState.updateAppClass('app-move for-dailog')
    },

    onCreateTeamVisible () {
      this.activeSection = MatchViewSection.Fantasy
    },

    onFantasyParticipated () {
      // this.activeSection = MatchViewSection.Game
    },

    onMatchUpdated (match) {
      this.match = match
      this.minuteLabel = this.match.minuteLabel
      const newTitle = this.match.info.title
      AppState.updateTitles(newTitle, newTitle)

      if (this.match.requiresLiveUpdate && (!this.pushInited)) {
        this.match.updateLatest(true)
        this.pushId = FootballPush.instance().listenMatch(this.match.info.key, (updatedMatch) => {
          this.match.overwrite(updatedMatch)
          this.onMatchUpdated(this.match)
        }, () => {
          this.minuteLabel = this.match.minuteLabel
        })
        this.pushInited = true
      }

      let newSections = [MatchViewSection.Info]

      if (this.match.havePlayersInfo) {
        // this.selectedPlayer = this.match.players['1017352760187818097']
        newSections.push(MatchViewSection.Team)
        newSections.push(MatchViewSection.Fantasy)
        // newSections.push(MatchViewSection.Game)	
      }

      if (this.match.timeline && this.match.timeline.length > 0) {
        newSections.push(MatchViewSection.Timeline)
      }

      if (this.match.stats) {
        newSections.push(MatchViewSection.Stats)
        // newSections.push(MatchViewSection.ManualStats)
      }

      this.sections = newSections

      if (this.appState.breadcrumb.length == 0) {
        let menu = [
          { title: this.match.info.tournament.short_name,
            route: {
              name: 'tournament', params: { key: this.match.info.tournament.key }
            } },
          { title: this.match.info.round.name,
            route: {
              name: 'tournamentRound', params: { key: this.match.info.tournament.key, roundkey: this.match.info.round.key }
          } }
        ]
        this.AppState.updateBreadcrumb(menu)
      }
    }
  }
}
</script>
